export default "__VITE_ASSET__BSR5FZ96__"